import { PencomCard } from "@/components/cards/PencomCard";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { PencomRoutes } from "@/router/PencomRoutes";

const PCCApplicationSuccessfulPage = () => {
    const navigate = useNavigate();
    const handleBackToDashboard = () => {
        navigate(PencomRoutes.DASHBOARD, { replace: true });
    }
    return (
        <div className="w-full flex flex-col items-center justify-center min-h-[calc(100vh-100px)]">
            <PencomCard className="w-[460px] flex flex-col items-center justify-center">
                <div className="flex flex-col gap-y-4 items-center justify-center">
                    <img src="/assets/icons/check-white.svg" alt="check" className="w-10 h-10" />
                    <p className="font-clash-display font-semibold text-2xl text-medium-dark-grey leading-[125%] tracking-[-1.5%]">Application Submitted</p>
                    <p className="font-clash-display font-regular text-sm text-medium-dark-grey leading-[18px] tracking-[-0.5%] text-center">Your Pencom Compliance Certificate application has been submitted and is under review. Approval usually takes a short time depending on volume.</p>
                    <PrimaryButton title="Back to Dashboard" onClick={handleBackToDashboard} className="mt-4 w-full" />
                </div>
            </PencomCard>
        </div>
    )
}

export default PCCApplicationSuccessfulPage;